import React, { useState, useEffect, useRef } from "react";
import "./chart_female.css";
import bottleImage from "../../../../../assets/Man-1-new.webp";

const Chart = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = '67%';
              setWaterPercentage(waterHeight);
            }, 300);

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="chart-section" ref={chartSectionRef}>
      <div className="equality-chart-1-female-container-2">
        <div className="male">
          <img className="female-image" src={bottleImage} alt="Bottle" />
          <div className="male-water" style={{ height: waterPercentage }} />
        </div>
      </div>
    </div>
  );
};

export default Chart;
